export { default as Headers } from './Headers'

export { headersToString } from './transformers/headersToString'
export { headersToList } from './transformers/headersToList'
export { headersToObject } from './transformers/headersToObject'
export { stringToHeaders } from './transformers/stringToHeaders'
export { listToHeaders } from './transformers/listToHeaders'
export { objectToHeaders } from './transformers/objectToHeaders'

export { reduceHeadersObject } from './transformers/reduceHeadersObject'
export { flattenHeadersList } from './transformers/flattenHeadersList'
export { flattenHeadersObject } from './transformers/flattenHeadersObject'

/* Typings */
export {
  HeadersList,
  FlatHeadersList,
  HeadersObject,
  FlatHeadersObject,
} from './glossary'
